import * as React from "react";
import {IUser} from "../../../config/user";
import {useGlobalStores} from "../../../hooks/use_global_stores";
import {updateEgo} from "../../../stores/users";
import {SnackbarStore} from "../../../stores/snackbar";
import {PageItem} from "../../Components/PageItem";
import {useForm} from "../../../hooks/use_form_v2";
import { Form } from "../../Components/Form/Form/Form";
import { DefaultCurrencyField } from "./Fields/DefaultCurrencyField";
import { EmailReadonlyField } from "./Fields/EmailReadonlyField";
import { DefaultLanguageField } from "./Fields/DefaultLanguageField";
import { DefaultPaymentMethodField } from "./Fields/PaymentMethodField";
import { IProfileForm, ProfileForm } from "../../../forms/settings_profile_form";
import { IUserProfile } from "../../../config/settings";

export const Profile = () => {
    const { userStore, snackbarStore } = useGlobalStores();
    const user = userStore.currentUser!;

    const form = useForm<IProfileForm, IUserProfile>(new ProfileForm(user));
    const { register, toRequest } = form;

    const handleSubmit = (values: IProfileForm) => {
        return updateEgo(toRequest(values))
            .then((user: IUser) => {
                snackbarStore.open(SnackbarStore.SUCCESS, 'Profile updated successfully!');
                userStore.setUser(user);
            })
            .catch((reason) => {
                snackbarStore.open(SnackbarStore.FAIL);
                return Promise.reject(reason);
            });
    };

    return (
        <PageItem title="Change your Profile">
            <Form form={form} onSubmit={handleSubmit}>
                <Form.Field type={EmailReadonlyField} email={user.email} />
                <Form.Field type={DefaultCurrencyField} {...register('default_currency')} />
                <Form.Field type={DefaultPaymentMethodField} {...register('default_payment_method_id')} />
                <Form.Field type={DefaultLanguageField} {...register('default_language')} />
            </Form>
        </PageItem>
    )
};
